import { render, staticRenderFns } from "./Kursliste.vue?vue&type=template&id=3eb1fcf6&"
import script from "./Kursliste.vue?vue&type=script&lang=js&"
export * from "./Kursliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports